import { SupportedLanguages } from '../../../../voice-response-command/vrc-audio-metadata/supported-languages';
import { speechDigitsProducedByMachine } from '../../../helper/was-answered-by-machine/speech-digits-produced-by-machine/speech-digits-produced-by-machine';
import { IVRKeyPresses } from '../../ivr/ivr-key-presses';
import { getKeyPressFromStr } from '../get-key-press-from-str/get-key-press-from-str';
import { normalizeSpeechResult } from '../normalize-speech-result';

import { DoesMatchKeyPressInput } from './interfaces';

export const doesMatchKeyPress = (params: DoesMatchKeyPressInput): boolean => {
  if (params.detectedSpeech === undefined) {
    return false;
  }

  if (speechDigitsProducedByMachine(params.detectedSpeech, params.detectedDigits)) {
    return false;
  }

  const filteredKeyPresses = params.keyPresses.filter((kp) => kp !== IVRKeyPresses.anyKey);

  if (filteredKeyPresses.length === 0) {
    return false;
  }

  const words = normalizeSpeechResult(params.detectedSpeech, SupportedLanguages.en).split(' ');

  const digitStr = words.map((word) => getKeyPressFromStr(word) ?? word).join('');

  if (digitStr.trim().length === 0) {
    return false;
  }

  return filteredKeyPresses.some((keyPress) => digitStr.includes(keyPress));
};
